import React from 'react';
import ReactDOM from 'react-dom';
import { StoreProvider } from './state/Context';
import App from './App';

ReactDOM.render(
  <StoreProvider>
    <App />
  </StoreProvider>,
  document.getElementById('root')
);

// hmr enable
// if (module.hot && process.env.NODE_ENV === 'development') {
//   module.hot.accept();
// }
